import React, { useEffect, useMemo, useState, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { imgUrl, siteUrl } from '../../config/config';
import { getProduct, getProductIdle } from '../../store/ducks/product/actions';
import productSelector from '../../store/ducks/product/selectors/productSelector';
//import moment from "moment";

import ProductNitrogen from './ProductNitrogen';
import ProductPhosphates from './ProductPhosphates';
import ProductFertilizers from './ProductFertilizers';
import ProductPotassium from './ProductPotassium';
import { PageMeta } from 'components/PageMeta/PageMeta';

import './Product.scss';

import FlipCard from './FlipCard';

import Page404 from '../../pages/404/404';
import { State } from 'types';

import { LangContext } from '../../components/App/App';

const Product = (props: any) => {
    const id: string = props.match.params.id;
    const dispatch = useDispatch();
    const product = useSelector(productSelector);
    const status = useSelector((state: State) => state.productReducer.status);
    const [firstLoad, setFirstLoad] = useState(true);
    const [flippedCards, setFlippedCards] = useState<number[]>([]);
    const lang = useContext(LangContext);

    useEffect(() => {
        if (id && lang && lang.lang && lang.lang.value && (status === 'IDLE' || !firstLoad)) {
            dispatch(getProduct({ slug: id, lang: lang.lang.value }));
        }
    }, [id, lang]);

    useEffect(() => {
        setFirstLoad(false);
        return () => {
            dispatch(getProductIdle());
        };
    }, []);

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const secret = queryParams.get('secret');
        const preview = queryParams.get('preview');
        if (secret && preview) {
            dispatch(getProduct({ slug: id, lang: lang.lang.value, preview: true }));
        }
    }, []);


    const changeFlippedCards = (action, id) => {
        if (action === 'add') {
            setFlippedCards([...flippedCards, id]);
        } else {
            let curCards: number[] = [...flippedCards];
            let cardIndex = curCards.indexOf(id);
            if (cardIndex > -1) {
                curCards.splice(cardIndex, 1);
            }
            setFlippedCards([...curCards]);
        }
    };

    if (status === 'FAILURE') {
        return <Page404 />;
    }

    return (
        <>
            {status === 'SUCCESS' && (
                <>
                    <PageMeta
                        title={product && product.title}
                        description={product && product.description}
                    />
                    <section className="product">
                        <div className="container">
                            <div className="product-wrapper">
                                <div className="product-left">
                                    <div className="product-info">
                                        <h1 className="product-title">
                                            {product && product.title}
                                        </h1>
                                        <div className="product-descr">
                                            {product && product.description}
                                        </div>
                                    </div>
                                    <Link
                                        to="/products"
                                        className="back-to-catalog"
                                    >
                                        <img
                                            src={
                                                imgUrl +
                                                'product/arrow-left.svg'
                                            }
                                            alt=""
                                        />
                                        <span>
                                            {(product &&
                                                product.backLinkCaption &&
                                                product.backLinkCaption) ||
                                                'Catalog'}
                                        </span>
                                    </Link>
                                </div>
                                <div className="product-poster">
                                    <img src={siteUrl + product.image} alt="" />
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="product-list">
                        <div className="container">
                            <div className="product-list__wrapper">
                                <div className="product-list__about no-img">
                                    {product &&
                                        product.reference &&
                                        product.reference.title && (
                                            <div className="product-list__about-title">
                                                {product.reference.title}
                                            </div>
                                        )}
                                    {product &&
                                        product.reference &&
                                        product.reference.caption && (
                                            <div className="product-list__about-descr">
                                                {product.reference.caption}
                                            </div>
                                        )}
                                    {product &&
                                        product.reference &&
                                        product.reference.url && (
                                            <>
                                                {(product.reference.type ===
                                                    'inner' && (
                                                    <Link
                                                        to={
                                                            product.reference
                                                                .url
                                                        }
                                                        className="product-list__about-link"
                                                    >
                                                        <img
                                                            src={
                                                                imgUrl +
                                                                'product/arrow-right-circle-fill.svg'
                                                            }
                                                            alt=""
                                                        />
                                                    </Link>
                                                )) || (
                                                    <a
                                                        href={
                                                            product.reference
                                                                .url
                                                        }
                                                        target="_blank"
                                                    >
                                                        <img
                                                            src={
                                                                imgUrl +
                                                                'product/arrow-right-circle-fill.svg'
                                                            }
                                                            alt=""
                                                        />
                                                    </a>
                                                )}
                                            </>
                                        )}
                                </div>
                                <div className="product-list__items">
                                    {product &&
                                        product.productCards &&
                                        product.productCards.length > 0 &&
                                        product.productCards.map(
                                            (item, index) => (
                                                <FlipCard
                                                    key={index}
                                                    flipped={
                                                        ((flippedCards.indexOf(
                                                            item.id
                                                        ) > -1 ||
                                                            item.cardFlipType ===
                                                                'back') &&
                                                            true) ||
                                                        false
                                                    }
                                                >
                                                    <div className="flip-card-inner">
                                                        <div className="flip-card-front">
                                                            <div
                                                                className={`product-list__item${
                                                                    (item.image &&
                                                                        ' present') ||
                                                                    ''
                                                                }`}
                                                            >
                                                                <div
                                                                    className={`product-list__item-top${
                                                                        (!item.image &&
                                                                            ' no-img') ||
                                                                        ''
                                                                    }`}
                                                                >
                                                                    {item.image && (
                                                                        <div className="product-list__item-present">
                                                                            <img
                                                                                src={
                                                                                    siteUrl +
                                                                                    item.image
                                                                                }
                                                                                alt=""
                                                                            />
                                                                        </div>
                                                                    )}
                                                                    <div className="product-list__item-title">
                                                                        {
                                                                            item.title
                                                                        }
                                                                    </div>
                                                                    {item.acronym && (
                                                                        <div className="product-list__item-abbrev">
                                                                            {
                                                                                item.acronym
                                                                            }
                                                                        </div>
                                                                    )}
                                                                </div>
                                                                <div className="product-list__item-bottom">
                                                                    <div className="product-list__item-descr">
                                                                        {
                                                                            item.caption
                                                                        }
                                                                    </div>
                                                                    {item.cardFlipType ===
                                                                        'both' && (
                                                                        <div
                                                                            className="product-list__item-info"
                                                                            onClick={() =>
                                                                                changeFlippedCards(
                                                                                    'add',
                                                                                    item.id
                                                                                )
                                                                            }
                                                                        >
                                                                            <img
                                                                                src={
                                                                                    imgUrl +
                                                                                    'product/info.svg'
                                                                                }
                                                                                alt=""
                                                                            />
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="flip-card-back">
                                                            <div className="product-list__item dark">
                                                                <div className="product-list__item-top">
                                                                    {item.logo && (
                                                                        <div className="product-list__item-logo">
                                                                            <img
                                                                                src={
                                                                                    imgUrl +
                                                                                    'logo.svg'
                                                                                }
                                                                                alt=""
                                                                            />
                                                                        </div>
                                                                    )}
                                                                    <div className="product-list__item-table">
                                                                        {item.cardOptions &&
                                                                            item
                                                                                .cardOptions
                                                                                .length >
                                                                                0 &&
                                                                            item.cardOptions.map(
                                                                                (
                                                                                    item,
                                                                                    index
                                                                                ) => (
                                                                                    <span
                                                                                        key={
                                                                                            index
                                                                                        }
                                                                                    >
                                                                                        {
                                                                                            item
                                                                                        }
                                                                                    </span>
                                                                                )
                                                                            )}
                                                                    </div>
                                                                    {item.document &&
                                                                        item
                                                                            .document
                                                                            .title &&
                                                                        item
                                                                            .document
                                                                            .url && (
                                                                            <a
                                                                                href={
                                                                                    siteUrl +
                                                                                    item
                                                                                        .document
                                                                                        .url
                                                                                }
                                                                                target="_blank"
                                                                            >
                                                                                <img
                                                                                    src={
                                                                                        imgUrl +
                                                                                        'product/file.svg'
                                                                                    }
                                                                                    alt=""
                                                                                />
                                                                                <span>
                                                                                    {
                                                                                        item
                                                                                            .document
                                                                                            .title
                                                                                    }
                                                                                </span>
                                                                            </a>
                                                                        )}
                                                                </div>
                                                                {item.cardFlipType ===
                                                                    'both' && (
                                                                    <div className="product-list__item-bottom">
                                                                        <div
                                                                            className="product-list__item-info"
                                                                            onClick={() =>
                                                                                changeFlippedCards(
                                                                                    'delete',
                                                                                    item.id
                                                                                )
                                                                            }
                                                                        >
                                                                            <img
                                                                                src={
                                                                                    imgUrl +
                                                                                    'product/info.svg'
                                                                                }
                                                                                alt=""
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </FlipCard>
                                            )
                                        )}
                                </div>
                            </div>
                        </div>
                    </section>
                </>
            )}
        </>
    );
};

export default Product;
